module.exports = __webpack_public_path__ + "assets/img/SpinTel-Social-Static-Ad.b60dbf4f.webp";